const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* AuraFitLab stable speed: feature MP4s load only after user interaction. */
(function () {
  const section = document.querySelector('.product_tab_sec');
  if (!section) return;

  const capsules = Array.from(section.querySelectorAll('.golden-capsule-three-col .img_container .capsule-img'));
  const headings = Array.from(section.querySelectorAll('.golden-capsule-three-col .item-headings > div'));

  capsules.forEach((capsule) => {
    const video = capsule.querySelector('video');
    const source = video && video.querySelector('source[data-src]');
    if (!source) return;
    source.dataset.deferredSrc = source.dataset.src;
    source.removeAttribute('data-src');
    video.removeAttribute('autoplay');
    video.preload = 'none';
  });

  function loadCapsule(index) {
    const capsule = capsules[index];
    if (!capsule) return;
    const video = capsule.querySelector('video');
    const source = video && video.querySelector('source');
    if (!video || !source) return;

    if (source.dataset.deferredSrc && !source.getAttribute('src')) {
      source.setAttribute('src', source.dataset.deferredSrc);
      delete source.dataset.deferredSrc;
      video.load();
    }

    video.muted = true;
    const playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  headings.forEach((heading, index) => {
    heading.addEventListener('click', function () {
      loadCapsule(index);
    });
  });

  section.addEventListener('pointerdown', function () {
    const activeIndex = Math.max(0, capsules.findIndex((capsule) => capsule.classList.contains('active')));
    loadCapsule(activeIndex);
  }, { once: true, passive: true });
})();
